import axios from "axios";

/**
 * Send an AJAX call to the main plugin API route (POST).
 */
export const doAjaxCall = async (action, data = {}) => {
  return axios
    .post(
      `${window.PolluxQuiz.api.rest_url}pollux-quiz/v1/public/${action}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": window.PolluxQuiz.api.nonce,
        },
        timeout: 15 * 1000,
      }
    )
    .then(
      (response) => {
        return Promise.resolve(response.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
};

/**
 * Wrapper function calling the AJAX route and returning an object based on the Promise.
 */
export const ajax = async (action, data = {}) => {
  try {
    const payload = await doAjaxCall(action, data);

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Process quiz.
 */
export const processQuiz = async (data) => {
  return await ajax("quiz-process", { data });
};
